import React, { useState } from 'react';
import HistorialRival from './HistorialRival';
import PartidosClub from '../PartidosClub';
import SelectorRival from './SelectorRival';
import BotoneraFiltros from '../../UI/BotoneraFiltros';
import * as Funciones from '../../funciones/FuncionesHistoriales';
import * as AgrupacionesTorneos from '../../constantes/AgrupacionesTorneos.js';
import * as TipoRival from '../../constantes/TipoRival.js';
import { ListaPartidos } from '../../constantes/Filtros.js';
import { getIdTipoRival } from '../../funciones/FuncionesHistoriales.js';
import styles from './RivalesClub.module.css';

const getFiltroPartidos = (tipoRival) => {
  const filtros = [
    {
      codigo: ListaPartidos.TOTALES,
      descripcion: 'Totales',
    },
  ];

  // Solo incluir ligas y copas nacionales si el rival es un club
  if (tipoRival === undefined || tipoRival === TipoRival.CLUB) {
    filtros.push({
      codigo: AgrupacionesTorneos.LIGAS_NACIONALES,
      descripcion: 'Liga Nacional',
    });
  }

  filtros.push(
    {
      codigo: AgrupacionesTorneos.COPAS_NACIONALES,
      descripcion: 'Copas Nacionales',
    },
    {
      codigo: AgrupacionesTorneos.INTERNACIONALES,
      descripcion: 'Internacionales',
    },
    { codigo: ListaPartidos.AMISTOSOS, descripcion: 'Amistosos' }
  );

  return filtros;
};

const RivalesClub = (props) => {
  const club = props.club;
  const [rival, setRival] = useState(Funciones.ArmarRival(null, null));
  const [filtro, setFiltro] = useState(ListaPartidos.TOTALES);

  const onRivalElegido = (tipoElegido, rivalElegido) => {
    if (tipoElegido && rivalElegido) {
      setRival(Funciones.ArmarRival(tipoElegido, rivalElegido));
    } else {
      setRival(Funciones.ArmarRival(null, null));
    }
  };

  const onFiltroElegido = (filtro) => {
    setFiltro(Number(filtro));
  };

  const tipoRival = rival && getIdTipoRival(rival);
  const filtroPartidos = getFiltroPartidos(tipoRival);

  return (
    <div className={`${styles.columnas}`}>
      <div className={`${styles.columnaSelector}`}>
        <SelectorRival club={club} onRivalElegido={onRivalElegido} />
        {rival && rival.objeto && (
          <div className={`${styles.columnaHistorialMobile}`}>
            <HistorialRival club={club} rival={rival} filtro={filtro} />
          </div>
        )}
      </div>
      {rival && rival.objeto && (
        <React.Fragment>
          <div className={`${styles.columnaFiltrosPartidos}`}>
            <div className={`${styles.columnaFiltros}`}>
              <BotoneraFiltros
                filtros={filtroPartidos}
                selected={filtro}
                onFiltroElegido={onFiltroElegido}
                onResetPagina={() => {}}
              />
            </div>
            <div className={`${styles.columnaPartidos}`}>
              <PartidosClub club={club} rival={rival} filtro={filtro} />
            </div>
          </div>
          <div className={`${styles.columnaHistorial}`}>
            <HistorialRival club={club} rival={rival} filtro={filtro} />
          </div>
        </React.Fragment>
      )}
    </div>
  );
};

export default RivalesClub;
